export default __webpack_public_path__ + "static/media/avatar_icon.ec4f9475.svg";